export const handleApiError = (status) => (async (dispatch, getState) => {
  if (status === 401) {
    dispatch({
      type: 'USER_AUTH_TOKEN_EXPIRED',
    });
  }
});
